function removeCommas(str) {
  if (!str) return "";
  return str.toString().replace(/,/g, "");
};

export default removeCommas;